module.exports = "<p>\n  single-company works!\n</p>\n"